import { MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modes } from '@constants/canvas/layers';
import { useProject } from '@context/Project';
import { useCanvasZoomActions } from '@hooks/canvas/useCanvasZoom';
import useProjectId from '@hooks/useProjectId';
import useScenarioMode from '@hooks/useScenarioMode';
import { ROUTES } from '@router/routes';
import {
  DashboardIcon,
  LightIcon,
  ModelingIcon,
  RiskRegisterIcon,
} from '@utils/iconsDefs';

const useToolboxLinks = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const id = useProjectId();
  const { scenarioMode } = useScenarioMode();
  const { saveCurrentZoom } = useCanvasZoomActions();

  const {
    toolbox: { mode },
    handleCloseDrawer,
  } = useProject();

  const toolboxLinks = [
    {
      label: 'Dashboard',
      Icon: DashboardIcon,
      to: (scenarioMode
        ? ROUTES.PROJECT.SCENARIO.DASHBOARD
        : ROUTES.PROJECT.DASHBOARD
      ).replace(':id', id),
    },
    {
      label: 'Model',
      Icon: ModelingIcon,
      to: (scenarioMode
        ? ROUTES.PROJECT.SCENARIO.MODEL
        : ROUTES.PROJECT.MODEL
      ).replace(':id', id),
    },
    ...(mode === Modes.RiskManagement
      ? [
          {
            label: 'Risk register',
            Icon: RiskRegisterIcon,
            to: scenarioMode
              ? ROUTES.PROJECT.SCENARIO.RISKS.replace(':id', id)
              : ROUTES.PROJECT.RISKS.replace(':id', id),
            type: 'riskRegister',
          },
        ]
      : [
          {
            label: 'Insights',
            Icon: LightIcon,
            to: (scenarioMode
              ? ROUTES.PROJECT.SCENARIO.INSIGHTS
              : ROUTES.PROJECT.INSIGHTS
            ).replace(':id', id),
          },
        ]),
  ];

  const handleLinkClick = async (
    e: MouseEvent<HTMLAnchorElement>,
    to: string,
  ) => {
    e.preventDefault();

    await handleCloseDrawer();

    saveCurrentZoom();

    navigate(to, {
      state: {
        fromInsights: location?.pathname?.includes('insights'),
      },
    });
  };

  return { toolboxLinks, handleLinkClick };
};

export default useToolboxLinks;
